module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": require("assets/case/05/img1.png")
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.05")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("上海93㎡萌趣三口之家，每天都像生活在游乐场")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝客户Sarah家有一个3岁的萌娃，为了给孩子创造一个充满童趣的空间，特地请了设计师夏天来做改造，把家变成“游乐场”。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("关于屋主")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Sarah，辣妈&手账达人。她与先生都是动漫迷，喜欢日式元素，手工咖啡重度爱好者。家有3岁萌娃。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("关于设计师")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("独立设计师夏天，《天天向上》特邀嘉宾，擅长色彩搭配及充满童趣的设计。")])]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("房子的基本信息")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海闵行")]), _vm._v(" "), _c('span', [_vm._v("面积：93㎡")]), _vm._v(" "), _c('span', [_vm._v("户型：两室一厅")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img2.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("玄关：手工达人的创作空间")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("进门是一个简单的玄关。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("辣妈Sarah是一个手工达人，嫌家里的防盗门有些旧了，就贴上毛毡“修缮一番”，好看又隔音。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("左手边原先是一个转角，做成玄关柜，收纳进出门的杂物。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img3.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅：给生活更多玩乐空间")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客餐厅连通成为一个大区域，厨房、小吧台、沙发区、餐厅区（观影区、收纳区）、地台儿童玩乐区一字排开。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img1.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("地台，孩子的专属领地")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("为了让孩子有独立的玩乐空间，阳台做成高出地面的10㎡地台。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在这里，小朋友可以爬到柜子里找玩具，坐在懂窝Q萌的布墩上看风景，在小书桌边看绘本……地暖给这个冬天更多玩乐的理由。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("地台上，特意留了3个小孔，用来放土种树，和孩子一同成长。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img5.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("餐厅，也是休闲娱乐区")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("打破原先的客厅区，将其变成餐厅区，带来更多活动空间。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝岩板桌，简洁设计，木元素餐椅，加入一点暖色。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("电视墙做成白色收纳柜，进入卧室的门也是白色，与橱柜连为整体，关上就像一整面墙。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这里同时也是观影区，平时把投影幕布隐藏起来。闲暇时刻，一家人围桌而坐，或者坐在地台上观影。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img6.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("沙发休闲区与岛台区")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Sarah的家弱化了沙发区的功能，只放了一张两人座沙发。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("夫妻俩都是咖啡重度爱好者，一个功能齐备的吧台区，满足随手冲咖啡的需求。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小豆丁形状的玻璃墙，能和在次卧玩耍的小朋友互动。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("另一面墙做成了洞洞板兼黑板墙，展示夫妻俩的收藏，还满足了孩子的涂涂画画。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img7.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("主卧：宁静的“蓝色海洋”")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("公共区域与私密性相对强的卧室、卫浴区，以白色的对门区隔。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧，蓝色的气质，让睡眠空间更宁静。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("还做了一个步入式衣帽间，以丝绒布帘隔开。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("床边放置了一个黄铜小边几代替床头柜，用来随手放手机、杯子。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img8.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("次卧：用撞色勾勒出活力")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("墙面做了色块处理，脏粉与灰的撞色，让空间多了很多活力。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝的沙发墩，灰色的布面与墙面呼应，Q萌外形很契合空间的气质。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("木床与灰色背景墙搭配，并不突兀。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("飘窗堆了几个懂窝的抱枕，闲时可随时倚靠。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img9.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("卫生间：干湿分离，好看实用")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卫生间干湿分离设计。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("淋浴区用黑色杆子隔开，贴上小花砖，用黑色梯子做收纳，风格很网红。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("干区黑色镜面浴室柜，用来收纳化妆品及洗漱用品，样式很高级。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("底部用灯带勾勒，收纳洗脸盆等，方便实用。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("洗衣机烘干机，刚好安置一旁。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("这样一个家，有趣，有爱，其乐融融，是最温馨最日常的生活状态。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/05/img10.png")
    }
  }), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么选择购买懂窝家具？")]), _vm._v("一开始是被懂窝家具的颜值所吸引，设计简约很有时尚感。后面仔细研究过产品，品质也非常好，一些设计细节（比如边角的处理）对小朋友也非常友好。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：希望给孩子打造一个怎样的家？")]), _vm._v("家是一个最让人放松的地方。我希望他能在这里开心的玩，快乐的长大。充满正能量，不仅有趣，还很有爱。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501ffe6f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/case5.vue
// module id = 445
// module chunks = 0